/**
 * Modul Checkout Steps > Events > Attendance
 */

import {
	needJquery, extend
} from '../../../../shared/utils/index';


import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from "../../../../shared/dom/manipulator";
import EventHandler from "../../../../shared/dom/event-handler";

import AjaxRequest from "../../../../shared/utils/ajax";

// ------
// Private
// ------

const $ = needJquery();
const CHECKOUT_NAME = 'events';
const CHECKOUT_CONTAINER = SelectorEngine.findOne(`[data-checkout="${CHECKOUT_NAME}"]`);

let eventCollection = {};

const registerEventForms = (id) => {
	let events = SelectorEngine.find(`.events-booking[data-user-id="${id}"]`);

	if(events.length) {
		eventCollection[id] = events;
		registerEventHandlers(id);
	}
};

const registerEventHandlers = (id) => {
	for(let form of eventCollection[id]) {
		// add edit flag to form
		EventHandler.on(form, 'click', '.button[data-event-edit]', () => {
			Manipulator.setDataAttribute(form, 'event-edit', 'true');
		});

		// add ajax submit handler to form
		EventHandler.on(form, 'submit', (event) => {
			event.preventDefault();

			const tableContainer = SelectorEngine.findOne('.table-outer', CHECKOUT_CONTAINER);

			let elementStatus = Manipulator.getDataAttribute(form, 'event-status');
			let isEdit        = Manipulator.getDataAttribute(form, 'event-edit');
			let typeInput = SelectorEngine.findOne(`.events-booking-type`, form);

			if(typeInput) {
				typeInput.value = elementStatus === 'available' || isEdit ? 'eventSelect' : 'eventUnselect';
			}

			let o = {
				url: form.getAttribute('action'),
				dataType: 'html',
				method: form.getAttribute('method') ? form.getAttribute('method') : 'post',
				data: $(form).serialize(),
				contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
				beforeSend: (data, status, xhr) => {
					console.log('before send');
					if(tableContainer) Manipulator.addClass(tableContainer, '-is-loading');
					Manipulator.addClass(form, '-is-loading');
				},
				success: (data, status, xhr) => {
					setTimeout(function() {
						pasteResponse(xhr);
						if(tableContainer) Manipulator.removeClass(tableContainer, '-is-loading');
						Manipulator.removeClass(form, '-is-loading');
					}, 500);
				},
				error: (data, status, xhr) => {
					setTimeout(function() {
						console.log('error');
					}, 500);
				}
			};

			const Request = new AjaxRequest(o);

			Request.init();
		});
	}
};

const pasteResponse = (response) => {
	const parser = new DOMParser();
	const parsedResponse = parser.parseFromString(response.responseText, 'text/html');

	const originalTable = document.querySelector('#event-table');
	const responseTable = parsedResponse.querySelector('#event-table');

	if (originalTable && responseTable) {
		originalTable.innerHTML = responseTable.innerHTML;

		startInit();
		initOptionModal();
		initCounterIndicator();
	}
};

const initCounterIndicator = () => {
	const COLLECTION = SelectorEngine.find(`.user-initials[data-user-id]`, CHECKOUT_CONTAINER);

	if(!COLLECTION.length) {
		return;
	}

	for(const ELEMENT of COLLECTION) {
		const userId = Manipulator.getDataAttribute(ELEMENT, 'user-id');
		const EVENT_COLLECTION = SelectorEngine.find(`.events-booking[data-user-id="${userId}"][data-event-status="booked"]`, CHECKOUT_CONTAINER);
		let eventCounter = EVENT_COLLECTION.length;
		let eventCounterElement = SelectorEngine.findOne(`.event-counter`, ELEMENT);

		eventCounterElement.textContent = eventCounter;
		eventCounterElement.style.display = eventCounter ? 'flex' : 'none';
	}
};

const initOptionModal = () => {
	const COLLECTION = SelectorEngine.find(`[data-target-form]`, CHECKOUT_CONTAINER);

	if(!COLLECTION.length) {
		return;
	}

	for(const CONTAINER of COLLECTION) {
		let containerAttr   = Manipulator.getDataAttribute(CONTAINER, 'target-form');
		let containerTarget = SelectorEngine.findOne(containerAttr);
		let submitBtn       = SelectorEngine.findOne(`button[data-trigger-form]`, CONTAINER);
		let formElements    = SelectorEngine.find(`[data-form-target]`, CONTAINER);

		if(!containerTarget) {
			return;
		}

		if(submitBtn) {
			EventHandler.on(submitBtn, 'click', (event) => {
				event.preventDefault();

				setTimeout(() => {
					// containerTarget.submit();
					EventHandler.trigger(containerTarget, 'submit');
					if(Fancybox) Fancybox.close();
				}, 200);
			});
		}

		if(formElements.length) {
			for(let element of formElements) {
				let elementAttr   = Manipulator.getDataAttribute(element, 'form-target');
				let elementTarget = SelectorEngine.findOne(elementAttr, containerTarget);

				if(!elementTarget) {
					return;
				}

				if(element.tagName.toLowerCase() !== 'textarea') {
					element.value = elementTarget.value;
				}

				EventHandler.on(element, 'change', (event) => {
					elementTarget.value = element.value;
				});
			}
		}
	}
};

const startInit = () => {
	const COLLECTION = SelectorEngine.find(`#event-table .user-initials[data-user-id]`, CHECKOUT_CONTAINER);

	if(!COLLECTION.length) return;

	for(const ELEMENT of COLLECTION) {
		registerEventForms(Manipulator.getDataAttribute(ELEMENT, 'user-id'));
	}
};

const initEvents = () => {
	startInit();
	initOptionModal();
};

// ------
// Public
// ------

const init = () => {
	if(CHECKOUT_CONTAINER) {
		initEvents();
		initCounterIndicator();
	}
};

// ------
// Export
// ------

export default {
	init : init
};